import { createFileRoute } from "@tanstack/react-router";
import DashboardSetari from "@/pages/DashboardSetari";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dashboard/setari/")({
  head: () => routeHead("/uk/dashboard/setari/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><DashboardSetari /></SubscribedRoute>
  );
}
